import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {loginByDing} from "@/pages/Integral/api_";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageClientWidth: 375,
    userId: '',
    deptId: '',
    localToken: '',
    selectedDate: '',
    roleId: ''
  },
  getters: {
  },
  mutations: {
    SET_USER_ID(state, id) {
      state.userId = id
    },
    SET_DEPT_ID(state, deptId) {
      state.deptId = deptId
    },
    SET_CLIENT_WIDTH(state, width) {
      state.pageClientWidth = width
    },
    SET_TOKEN(state, token) {
      state.localToken = token
    },
    SET_ROLE_ID(state, roleId) {
      state.roleId = roleId
    },
    SAFETY_OPERATION(state, selectedDate) {
      state.selectedDate = selectedDate
    }
  },
  actions: {
    fetchGetToken({ commit }) {
      const u = navigator.userAgent, app = navigator.appVersion;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      let token
      if(isiOS){
        token = window.prompt("getToken");
      }else{
        token = window.android.getToken();
      }

      const axiosUrl = process.env.VUE_APP_CURENV === "development" ? 'http://eastair-test.bafangintel.cn/api/app/api/user/dd/userId' : 'https://v2eastair.bfintel.cn/api/app/api/user/dd/userId'

      axios.get(axiosUrl, { headers: {'Blade-Auth': 'bearer ' + token} }).then(res => {
        if (res.data.code !== 200) return
        loginByDing({
          dingding: res.data.data,
          grant_type: 'dingding'
        }).then(res => {
          console.log('res >>> ', res)
          localStorage.setItem("mobile_token", res.access_token)
          commit('SET_TOKEN', res.access_token)
          commit('SET_USER_ID', res.user_id)
          commit('SET_DEPT_ID', res.dept_id)
        })
      })
    }
  },
  modules: {
  }
})
